export const Newsletter = () => {
    return (
     <section class="bg-light py-5">
        <div class="container text-center">
            <div class="row">
                <div class="col-lg-7 mx-auto">
                    <p class="h6 text-uppercase text-theme">Newsletter</p>
                    <h2 class="mb-3">Stay up to date with useful tips via our newsletter</h2>
                    <p class="text-muted mb-5">Lorem ipsum dolor sit amet, consetetur sadipscing elite.</p>
                    <form class="p-2 bg-white rounded shadow-sm">
                        <div class="input-group p-1">
                            <input class="form-control border-0 shadow-0" type="email" placeholder="Enter your email address"/>
                            <button class="btn btn-theme rounded ms-1" type="submit">Subscribe</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
    )
}

export default Newsletter;